module.exports = __webpack_public_path__ + "Pe-icon-7-strokebb1d.b38ef310874bdd008ac1.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/pe-icon-7-stroke/fonts/Pe-icon-7-strokebb1d.woff?d7yf1v
// module id = ../../../../../src/assets/pe-icon-7-stroke/fonts/Pe-icon-7-strokebb1d.woff?d7yf1v
// module chunks = styles